import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AutoguardGuard} from './shared/autoguard.guard';
import {environment} from '../environments/environment';

const appRoutes: Routes = [
  {
    path: 'cli/activity/list',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/cli/cli-activity-list/cli-activity-list.module').then(
        (mod) => mod.CliActivityListModule,
      ),
    data: {enablePottosTracking: true},
  },
  {
    path: 'cli/empty_email_append/:email_append_token',
    loadChildren: () =>
      import('./pages/cli/cli-mail-new/cli-mail-new.module').then((mod) => mod.CliMailNewModule),
    data: {enablePottosTracking: false},
  },
  {
    path: 'cli/executive/template',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/cli/cli-executive-template/cli-executive-template.module').then(
        (mod) => mod.CliExecutiveTemplateModule,
      ),
    data: {enablePottosTracking: true},
  },
  {
    path: 'cli/home',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/cli/cli-home/cli-home.module').then((mod) => mod.CliHomeModule),
    data: {enablePottosTracking: true},
  },
  {
    path: 'cli/import/list',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/cli/cli-import-list/cli-import-list.module').then(
        (mod) => mod.CliImportListModule,
      ),
    data: {enablePottosTracking: true},
  },
  {
    path: 'cli/incident_template',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/cli/cli-incident-template/cli-incident-template.module').then(
        (mod) => mod.CliIncidentTemplateModule,
      ),
    data: {enablePottosTracking: true},
  },
  {
    path: 'cli/login',
    loadChildren: () =>
      import('./pages/cli/cli-login/cli-login.module').then((mod) => mod.CliLoginModule),
    data: {enablePottosTracking: false},
  },
  {
    path: 'cli/mail/confirm',
    loadChildren: () =>
      import('./pages/cli/cli-mail-confirm/cli-mail-confirm.module').then(
        (mod) => mod.CliMailConfirmModule,
      ),
    data: {enablePottosTracking: false},
  },
  {
    path: 'cli/mail_template',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/cli/cli-mail-template/cli-mail-template.module').then(
        (mod) => mod.CliMailTemplateModule,
      ),
    data: {enablePottosTracking: true},
  },
  {
    path: 'cli/manual_boot',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/cli/cli-manual-boot/cli-manual-boot.module').then(
        (mod) => mod.CliManualBootModule,
      ),
    data: {enablePottosTracking: true},
  },
  {
    path: 'cli/node',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/cli/cli-node/cli-node.module').then((mod) => mod.CliNodeModule),
    data: {enablePottosTracking: true},
  },
  {
    path: 'cli/protocol',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/cli/cli-protocol/cli-protocol.module').then((mod) => mod.CliProtocolModule),
    data: {enablePottosTracking: true},
  },
  {
    path: 'cli/remember',
    loadChildren: () =>
      import('./pages/cli/cli-remember/cli-remember.module').then((mod) => mod.CliRememberModule),
    data: {enablePottosTracking: false},
  },
  {
    path: 'cli/response',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/cli/cli-response/cli-response.module').then((mod) => mod.CliResponseModule),
    data: {enablePottosTracking: true},
  },
  {
    path: 'cli/setting',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/cli/cli-setting/cli-setting.module').then((mod) => mod.CliSettingModule),
    data: {enablePottosTracking: true},
  },
  {
    path: 'cli/staff/self',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/cli/cli-staff/cli-staff.module').then((mod) => mod.CliStaffSelfModule),
    data: {enablePottosTracking: true},
  },
  {
    path: 'cli/tag',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/cli/cli-tag/cli-tag.module').then((mod) => mod.CliTagModule),
    data: {enablePottosTracking: true},
  },
  {
    path: 'cli/user',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/cli/cli-user/cli-user.module').then((mod) => mod.CliUserModule),
    data: {enablePottosTracking: true},
  },
  {
    path: 'cli',
    loadChildren: () =>
      import('./pages/cli/cli-incident/cli-incident.module').then((mod) => mod.CliIncidentModule),
    data: {enablePottosTracking: true},
  },
  {
    path: 'sys/administrator',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/sys/sys-adminstrator/sys-administrator.module').then(
        (mod) => mod.SysAdministratorModule,
      ),
    data: {enablePottosTracking: false},
  },
  {
    path: 'sys/category/sample',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/sys/sys-category-sample/sys-category-sample.module').then(
        (mod) => mod.SysCategorySampleModule,
      ),
    data: {enablePottosTracking: false},
  },
  {
    path: 'sys/client',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/sys/sys-client/sys-client.module').then((mod) => mod.SysClientModule),
    data: {enablePottosTracking: false},
  },
  {
    path: 'sys/content',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/sys/sys-content/sys-content.module').then((mod) => mod.SysContentModule),
    data: {enablePottosTracking: false},
  },
  {
    path: 'sys/home',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/sys/sys-home/sys-home.module').then((mod) => mod.SysHomeModule),
    data: {enablePottosTracking: false},
  },
  {
    path: 'sys/login',
    loadChildren: () =>
      import('./pages/sys/sys-login/sys-login.module').then((mod) => mod.SysLoginModule),
    data: {enablePottosTracking: false},
  },
  {
    path: 'sys/manual/boot/incident',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/sys/sys-manual-boot-incident/sys-manual-boot-incident.module').then(
        (mod) => mod.SysManualBootIncidentModule,
      ),
    data: {enablePottosTracking: false},
  },
  {
    path: '',
    redirectTo: environment.rootRedirectPath,
    pathMatch: 'full',
  },
  {
    path: '**',
    canActivate: [AutoguardGuard],
    loadChildren: () =>
      import('./pages/cli/cli-login/cli-login.module').then((mod) => mod.CliLoginModule),
    data: {enablePottosTracking: false},
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, {enableTracing: false})],
  exports: [RouterModule],
  providers: [AutoguardGuard],
})
export class AppRoutingModule {}
